<template>
  <HeaderBar />
  <section class="carvia-container">
    <UserSettings />
    <EvidenceUploadQueueSection />
    <DeviceConnectSection />

    <template v-if="$can('update', 'GlobalSettings')">
      <Divider />
      <GlobalSettings />
    </template>
  </section>
</template>

<script setup lang="ts">
import HeaderBar from '@/components/headerbar/HeaderBar.vue';
import { watchEffect } from 'vue';
import { useUiStore } from '@/stores/ui.store';
import { useI18n } from 'vue-i18n';
import UserSettings from './UserSettings.vue';
import GlobalSettings from './GlobalSettings.vue';
import Divider from '@/components/Divider.vue';
import DeviceConnectSection from './DeviceConnectSection.vue';
import EvidenceUploadQueueSection from './EvidenceUploadQueueSection.vue';

const { t } = useI18n();

watchEffect(() => {
  useUiStore().setHeaderTitle(t('settings'));
});
</script>

<i18n lang="json">
{
  "en": {
    "settings": "Settings",
    "resetAdyenSession": "Reset Adyen Session"
  },
  "de": {
    "settings": "Einstellungen",
    "resetAdyenSession": "Adyen-Session zurücksetzen"
  },
  "es": {
    "settings": "Ajustes",
    "resetAdyenSession": "Restablecer sesión de Adyen"
  }
}
</i18n>
